import React from "react";
import UnsavedChanges from "../ui/UnsavedChanges";

const SaveButton = (props) => {
  return <UnsavedChanges {...props} />;
};

export default SaveButton;
